/* generated by scripts/generate.mjs; do not edit */
/** Card `$defs` closure for the asset lock/manifest `meta` blocks (sprite, rig, kit, geometry). */
export const assetCardMetaDefs = {
    "assetPath": {
        "type": "string",
        "pattern": "^(?!/)(?!\\.\\.(?:/|$))(?!.*\\/\\.\\.(?:\\/|$))[^\\\\]+$",
        "description": "Relative path inside the collection; traversal and backslashes are forbidden."
    },
    "assetPathList": {
        "type": "array",
        "minItems": 1,
        "items": {
            "$ref": "#/$defs/assetPath"
        }
    },
    "clip": {
        "type": "object",
        "required": [
            "name",
            "duration_s"
        ],
        "properties": {
            "name": {
                "type": "string"
            },
            "duration_s": {
                "type": "number",
                "minimum": 0
            },
            "canonical": {
                "$ref": "#/$defs/vocab.canonicalClip",
                "description": "Mapped by code from the name (synonym table), so agents can ask for 'die' whatever the vendor calls it."
            },
            "loop": {
                "type": "boolean"
            },
            "root_motion": {
                "type": "boolean"
            }
        },
        "additionalProperties": false
    },
    "geometry": {
        "type": "object",
        "description": "3D facts, measured by code after B11 normalization (1 unit = 1 m, Y-up, origin at base).",
        "required": [
            "bounds_m",
            "triangles",
            "normalized"
        ],
        "properties": {
            "bounds_m": {
                "type": "object",
                "required": [
                    "min",
                    "max"
                ],
                "properties": {
                    "min": {
                        "$ref": "#/$defs/vec3"
                    },
                    "max": {
                        "$ref": "#/$defs/vec3"
                    }
                },
                "additionalProperties": false
            },
            "footprint_cells": {
                "type": "object",
                "required": [
                    "w",
                    "d",
                    "cell_m"
                ],
                "properties": {
                    "w": {
                        "type": "number"
                    },
                    "d": {
                        "type": "number"
                    },
                    "cell_m": {
                        "type": "number",
                        "exclusiveMinimum": 0
                    }
                },
                "additionalProperties": false
            },
            "pivot": {
                "enum": [
                    "base-center",
                    "center",
                    "base-corner",
                    "other"
                ]
            },
            "triangles": {
                "type": "integer",
                "minimum": 0
            },
            "vertices": {
                "type": "integer",
                "minimum": 0
            },
            "materials": {
                "type": "array",
                "items": {
                    "type": "string"
                }
            },
            "texture_keys": {
                "type": "array",
                "items": {
                    "type": "string"
                },
                "description": "Textures used, by path within the collection; a shared atlas shows up as the same entry on many cards."
            },
            "has_collision_mesh": {
                "type": "boolean"
            },
            "lod_count": {
                "type": "integer",
                "minimum": 0
            },
            "normalized": {
                "type": "boolean",
                "description": "False until B11 normalization ran; bounds are then in source units."
            }
        },
        "additionalProperties": false
    },
    "kit": {
        "type": "object",
        "required": [
            "piece",
            "grid_m"
        ],
        "properties": {
            "piece": {
                "$ref": "#/$defs/vocab.kitPiece"
            },
            "grid_m": {
                "type": "number",
                "exclusiveMinimum": 0
            },
            "height_m": {
                "type": "number",
                "minimum": 0
            },
            "open_edges": {
                "type": "array",
                "items": {
                    "$ref": "#/$defs/vocab.edge"
                },
                "uniqueItems": true,
                "description": "Edges a neighbour piece can attach to."
            },
            "connects_to": {
                "type": "array",
                "items": {
                    "$ref": "#/$defs/vocab.kitPiece"
                },
                "uniqueItems": true
            }
        },
        "additionalProperties": false
    },
    "rig": {
        "type": "object",
        "required": [
            "rig_type",
            "rig_id",
            "joint_count"
        ],
        "properties": {
            "rig_type": {
                "enum": [
                    "humanoid",
                    "quadruped",
                    "creature",
                    "vehicle",
                    "custom"
                ]
            },
            "rig_id": {
                "type": "string",
                "pattern": "^rig:[0-9a-f]{12}$",
                "description": "Hash of the sorted joint names plus parent links. Same rig_id = animations transfer. 'Shares a rig with' is an index query on this field, not stored on the card."
            },
            "joint_count": {
                "type": "integer",
                "minimum": 1
            },
            "retarget_rig_id": {
                "type": "string",
                "pattern": "^rig:[0-9a-f]{12}$",
                "description": "A different rig whose clips play on this skeleton: every joint here exists there with the same parent; tracks for that rig's extra joints are dropped. Set when no clip library targets rig_id itself."
            },
            "attach_points": {
                "type": "array",
                "items": {
                    "type": "object",
                    "required": [
                        "slot",
                        "joint"
                    ],
                    "properties": {
                        "slot": {
                            "enum": [
                                "hand-right",
                                "hand-left",
                                "head",
                                "back",
                                "hip",
                                "root"
                            ]
                        },
                        "joint": {
                            "type": "string"
                        }
                    },
                    "additionalProperties": false
                }
            },
            "clips": {
                "type": "array",
                "items": {
                    "$ref": "#/$defs/clip"
                }
            }
        },
        "additionalProperties": false
    },
    "sprite": {
        "type": "object",
        "required": [
            "drawn_view"
        ],
        "properties": {
            "drawn_view": {
                "$ref": "#/$defs/vocab.drawnView"
            },
            "tile_px": {
                "type": "integer",
                "minimum": 1
            },
            "sheet": {
                "type": "object",
                "required": [
                    "frame_w",
                    "frame_h",
                    "cols",
                    "rows"
                ],
                "properties": {
                    "frame_w": {
                        "type": "integer"
                    },
                    "frame_h": {
                        "type": "integer"
                    },
                    "cols": {
                        "type": "integer"
                    },
                    "rows": {
                        "type": "integer"
                    },
                    "spacing_px": {
                        "type": "integer",
                        "minimum": 0
                    },
                    "margin_px": {
                        "type": "integer",
                        "minimum": 0
                    }
                },
                "additionalProperties": false
            },
            "sheet_index": {
                "type": "integer",
                "minimum": 0,
                "description": "Position in the collection's packed tilesheet, when one exists."
            },
            "animations": {
                "type": "array",
                "items": {
                    "type": "object",
                    "required": [
                        "name",
                        "frames"
                    ],
                    "properties": {
                        "name": {
                            "type": "string"
                        },
                        "frames": {
                            "type": "array",
                            "items": {
                                "type": "integer"
                            }
                        },
                        "fps": {
                            "type": "number"
                        },
                        "directions": {
                            "type": "array",
                            "minItems": 1,
                            "uniqueItems": true,
                            "items": {
                                "$ref": "#/$defs/vocab.direction"
                            }
                        },
                        "sheets": {
                            "type": "array",
                            "minItems": 1,
                            "items": {
                                "type": "object",
                                "required": [
                                    "path",
                                    "frame_w",
                                    "frame_h",
                                    "cols",
                                    "rows"
                                ],
                                "properties": {
                                    "path": {
                                        "$ref": "#/$defs/assetPath"
                                    },
                                    "variant": {
                                        "enum": [
                                            "shadowless",
                                            "shadow"
                                        ]
                                    },
                                    "frame_w": {
                                        "type": "integer",
                                        "minimum": 1
                                    },
                                    "frame_h": {
                                        "type": "integer",
                                        "minimum": 1
                                    },
                                    "cols": {
                                        "type": "integer",
                                        "minimum": 1
                                    },
                                    "rows": {
                                        "type": "integer",
                                        "minimum": 1
                                    }
                                },
                                "additionalProperties": false
                            }
                        },
                        "files": {
                            "type": "array",
                            "minItems": 1,
                            "items": {
                                "$ref": "#/$defs/assetPath"
                            }
                        },
                        "direction_files": {
                            "type": "object",
                            "minProperties": 1,
                            "properties": {
                                "E": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "N": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "NE": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "NW": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "S": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "SE": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "SW": {
                                    "$ref": "#/$defs/assetPathList"
                                },
                                "W": {
                                    "$ref": "#/$defs/assetPathList"
                                }
                            },
                            "additionalProperties": false
                        }
                    },
                    "additionalProperties": false
                }
            },
            "facings": {
                "type": "object",
                "minProperties": 1,
                "properties": {
                    "E": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "N": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "NE": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "NW": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "S": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "SE": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "SW": {
                        "$ref": "#/$defs/assetPath"
                    },
                    "W": {
                        "$ref": "#/$defs/assetPath"
                    }
                },
                "additionalProperties": false
            },
            "tile": {
                "type": "object",
                "properties": {
                    "layer": {
                        "enum": [
                            "ground",
                            "wall",
                            "decor",
                            "overlay",
                            "entity"
                        ]
                    },
                    "autotile": {
                        "enum": [
                            "none",
                            "blob-47",
                            "wang-16",
                            "edge-9"
                        ]
                    },
                    "walkable": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "nine_slice": {
                "type": "array",
                "items": {
                    "type": "integer",
                    "minimum": 0
                },
                "minItems": 4,
                "maxItems": 4,
                "description": "UI panels: left, top, right, bottom insets in px."
            }
        },
        "additionalProperties": false
    },
    "vec3": {
        "type": "array",
        "items": {
            "type": "number"
        },
        "minItems": 3,
        "maxItems": 3
    },
    "vocab.canonicalClip": {
        "enum": [
            "idle",
            "walk",
            "run",
            "sprint",
            "jump",
            "fall",
            "land",
            "crouch",
            "sit",
            "attack-melee",
            "attack-ranged",
            "attack-kick",
            "cast",
            "block",
            "hit",
            "die",
            "pick-up",
            "interact",
            "emote",
            "hold",
            "drive",
            "swim",
            "climb",
            "other"
        ]
    },
    "vocab.direction": {
        "enum": [
            "E",
            "N",
            "NE",
            "NW",
            "S",
            "SE",
            "SW",
            "W"
        ]
    },
    "vocab.drawnView": {
        "enum": [
            "topdown",
            "side",
            "iso",
            "front",
            "three-quarter",
            "none"
        ]
    },
    "vocab.edge": {
        "enum": [
            "n",
            "e",
            "s",
            "w",
            "top",
            "bottom"
        ]
    },
    "vocab.kitPiece": {
        "enum": [
            "floor",
            "floor-detail",
            "wall",
            "wall-half",
            "wall-narrow",
            "wall-corner",
            "wall-opening",
            "wall-end",
            "door",
            "gate",
            "stairs",
            "column",
            "ceiling",
            "roof",
            "road",
            "road-corner",
            "road-junction",
            "fence",
            "bridge",
            "support",
            "other"
        ]
    }
};
//# sourceMappingURL=card.generated.js.map